/* 企业服务 》企业充值 */
import request from "@/utils/request";
import qs from "qs";


/* 充值 */
export function companyPayByMoreMain(data) {
  return request({
    url: '?m=Pay&a=company',
    method: 'post',
    data:qs.stringify(data)
  })
}

/* 续费( 单主体 ) */
export function companyRenewByMain(data) {
  return request({
    url: '?m=Pay&a=mainRenewal',
    method: 'post',
    data: qs.stringify(data)
  })
}

/* 加购账号 */
export function companyPayByAccount(data) {
  return request({
    url: '?m=Pay&a=addAccount',
    method: 'post',
    data: qs.stringify(data)
  })
}


/* 充值记录 */
export function getPayRecord(query) {
  return request({
    url: '?m=Company&a=payRecord',
    method: 'get',
    params: query
  })
}

/* 续费账号主体列表 */
export function getMainListByRenew(query) {
  return request({
    url: '?m=Company&a=renewMain',
    method: 'get',
    params: query
  })
}

export function getCouponByNewYear(query) {
  return request({
    url: '?m=Coupon&a=activityCoupon',
    method: 'get',
    params: query
  })
}
